var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstantFormAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.8,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    color: "currentColor",
    "aria-hidden": "true",
    focusable: "false",
    style: {
      color: "currentColor"
    },
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12h.01"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantFormAd);
export default __webpack_public_path__ + "static/media/instant-form-ad.87cd28d87b42a918be7daf097d6f04da.svg";
export { ForwardRef as ReactComponent };